/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:26
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-03 11:20:03
 */
import template from '@/app/editor/sidebar/templates/gfElement/checkbox.html';

export const checkboxSettings = [
  {
    name: 'name',
    caption: 'Name',
    type: 'text',
    class: 'name',
    target: '.gf_checkbox',
    ref: 'attr|name',
  },
  {
    name: 'description',
    id: 'description',
    caption: 'Description',
    type: 'textarea',
    default_value: '',
    target: '.elm span',
    ref: 'html|html',
  },
  {
    name: 'required',
    id: 'required',
    class: 'gf_to-switch',
    caption: 'Required',
    type: 'input',
    default_value: '0',
    desc: 'Make this field required.',
    target: '.gf_checkbox',
    ref: 'attr|required',
  },
  {
    name: 'selected',
    id: 'selected',
    class: 'gf_to-switch',
    caption: 'Selected',
    type: 'input',
    default_value: '0',
    desc: 'Selected as default.',
    target: '.gf_checkbox',
    ref: 'attr|checked',
  },
  {
    caption: 'Typography',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'font-size',
        id: 'font-size',
        class: 'gf_to-range',
        caption: 'Font Size',
        type: 'input',
        min: '0',
        max: '100',
        step: '1',
        unit: 'px',
        default_value: '20px',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|font-size',
      },
      {
        name: 'line-height',
        id: 'line-height',
        class: 'gf_to-range',
        caption: 'Line Height',
        type: 'input',
        min: '0.5',
        max: '3',
        step: '0.1',
        unit: 'em',
        default_value: '1.2em',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|line-height',
      },
      {
        name: 'letter-spacing',
        id: 'letter-spacing',
        class: 'gf_to-range',
        caption: 'Letter Spacing',
        type: 'input',
        min: '-1',
        max: '4',
        step: '0.1',
        unit: 'px',
        default_value: '1',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|letter-spacing',
      },
      {
        name: 'color',
        id: 'color',
        class: 'gryff-color',
        caption: 'Color',
        type: 'text',
        default_value: '#2d313f',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|color',
      },
      {
        name: 'font',
        id: 'font',
        class: 'gf_font',
        caption: 'Font',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|font-family',
      },
    ],
  },
  {
    caption: 'Checkbox',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'padding',
        id: 'padding',
        class: 'gf_to-range',
        caption: 'Spacing',
        type: 'input',
        min: '0',
        max: '50',
        step: '1',
        unit: 'px',
        default_value: '5px',
        mode: 'responsive-mode',
        target: '.elm span',
        ref: 'css|padding-left',
      },
      {
        name: 'position',
        id: 'position',
        class: 'gf_to-range',
        caption: 'Position',
        type: 'input',
        min: '-20',
        max: '20',
        step: '1',
        unit: 'px',
        default_value: '0px',
        mode: 'responsive-mode',
        target: '.gf_checkbox',
        ref: 'css|top',
      },
    ],
  },
  {
    id: 'alignment',
    name: 'alignment',
    class: 'gf_to-align',
    caption: 'Alignment',
    type: 'select',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.gf_checkbox',
    ref: 'class|classname',
  },
];

export default {
  name: 'Checkbox',
  slug: 'checkbox',
  class: 'gf_checkbox',
  id: 'md-checkbox',
  html: template(),
  settings: checkboxSettings,
};
